/**
 * @fileoverview added by tsickle
 * Generated from: components/alerts/formio.alerts.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormioAlerts } from './formio.alerts';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function FormioAlertsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function FormioAlertsComponent_div_0_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); var alert_r1 = ctx.$implicit; var ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.getComponent($event, alert_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var alert_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("alert alert-", alert_r1.type, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(alert_r1.message);
} }
var FormioAlertsComponent = /** @class */ (function () {
    function FormioAlertsComponent() {
        this.focusComponent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    FormioAlertsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.alerts) {
            this.alerts = new FormioAlerts();
        }
    };
    /**
     * @param {?} event
     * @param {?} alert
     * @return {?}
     */
    FormioAlertsComponent.prototype.getComponent = /**
     * @param {?} event
     * @param {?} alert
     * @return {?}
     */
    function (event, alert) {
        this.focusComponent.emit(alert.component.key);
    };
    FormioAlertsComponent.propDecorators = {
        alerts: [{ type: Input }],
        focusComponent: [{ type: Output }]
    };
FormioAlertsComponent.ɵfac = function FormioAlertsComponent_Factory(t) { return new (t || FormioAlertsComponent)(); };
FormioAlertsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormioAlertsComponent, selectors: [["formio-alerts"]], inputs: { alerts: "alerts" }, outputs: { focusComponent: "focusComponent" }, decls: 1, vars: 1, consts: [["role", "alert", 3, "class", "click", 4, "ngFor", "ngForOf"], ["role", "alert", 3, "click"]], template: function FormioAlertsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormioAlertsComponent_div_0_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.alerts.alerts);
    } }, directives: [ɵngcc1.NgForOf], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormioAlertsComponent, [{
        type: Component,
        args: [{
                selector: 'formio-alerts',
                template: "<div *ngFor=\"let alert of alerts.alerts\" class=\"alert alert-{{ alert.type }}\" role=\"alert\" (click)=\"getComponent($event, alert)\">{{ alert.message }}</div> "
            }]
    }], function () { return []; }, { focusComponent: [{
            type: Output
        }], alerts: [{
            type: Input
        }] }); })();
    return FormioAlertsComponent;
}());
export { FormioAlertsComponent };
if (false) {
    /** @type {?} */
    FormioAlertsComponent.prototype.alerts;
    /** @type {?} */
    FormioAlertsComponent.prototype.focusComponent;
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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